"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setStatusMetadata = exports.saveSelectedPetQuote = exports.saveQuote = exports.savePromotionDetail = exports.resetQuote = exports.removePromotionDetail = exports.quoteSlice = exports.processSearchParams = exports.UPDATE_STATUS = exports.PROMO_VALIDATION_STATUS = exports.FETCH_STATUS = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _initialQuote = require("../../constants/quote/initialQuote");
var _constants = require("../../constants/constants");
var _storageKeys = require("../../constants/app/storageKeys");
var _breeds = require("../../helpers/breeds");
var _metadata;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var FETCH_STATUS = exports.FETCH_STATUS = 'initialFetchStatus';
var UPDATE_STATUS = exports.UPDATE_STATUS = 'updateStatus';
var PROMO_VALIDATION_STATUS = exports.PROMO_VALIDATION_STATUS = 'promoValidationStatus';
var initialState = {
  metadata: (_metadata = {}, _defineProperty(_metadata, FETCH_STATUS, _constants.STATUS_IDLE), _defineProperty(_metadata, UPDATE_STATUS, _constants.STATUS_IDLE), _defineProperty(_metadata, PROMO_VALIDATION_STATUS, _constants.STATUS_IDLE), _metadata),
  status: _constants.STATUS_IDLE,
  quote: _initialQuote.INITIAL_QUOTE
};
var quoteSlice = exports.quoteSlice = (0, _toolkit.createSlice)({
  name: 'quote',
  initialState: initialState,
  reducers: {
    saveQuote: function saveQuote(state, action) {
      var _action$payload;
      var owner = (action === null || action === void 0 || (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.owner) || {};
      var fullAddress = owner.address !== null && owner.state !== null && owner.suburb !== null ? "".concat(owner.address, ", ").concat(owner.suburb, ", ").concat(owner.state, ", ").concat(owner.postcode) : null;
      state.quote = _objectSpread(_objectSpread(_objectSpread({}, state.quote), action.payload), {}, {
        owner: _objectSpread(_objectSpread({}, action.payload.owner), {}, {
          fullAddress: fullAddress
        })
      });
    },
    saveSelectedPetQuote: function saveSelectedPetQuote(state, action) {
      var _action$payload2 = action.payload,
        petNumber = _action$payload2.petNumber,
        selectedQuote = _action$payload2.selectedQuote;
      if (petNumber < 0 || petNumber >= state.quote.pets.length) {
        /* eslint-disable-next-line no-console */
        console.error('Index out of range');
        return;
      }
      state.quote.pets[petNumber].selectedQuote = selectedQuote;
    },
    savePromotionDetail: function savePromotionDetail(state, action) {
      var _action$payload3 = action.payload,
        promotionNo = _action$payload3.promotionNo,
        promotionMessage = _action$payload3.promotionMessage,
        promotionCode = _action$payload3.promotionCode,
        promotionContent = _action$payload3.promotionContent;
      state.quote = _objectSpread(_objectSpread({}, state.quote), {}, {
        promotionNo: promotionNo,
        promotionMessage: promotionMessage,
        hasValidPromotion: true,
        promotionCode: promotionCode,
        promotionContent: promotionContent,
        hasPromotionCode: true
      });
    },
    removePromotionDetail: function removePromotionDetail(state, _) {
      state.quote = _objectSpread(_objectSpread({}, state.quote), {}, {
        promotionNo: null,
        promotionMessage: null,
        hasValidPromotion: null,
        hasPromotionCode: false,
        promotionCode: null
      });
    },
    setStatusMetadata: function setStatusMetadata(state, action) {
      var _action$payload4 = action.payload,
        value = _action$payload4.value,
        name = _action$payload4.name;
      var nameIsValid = [UPDATE_STATUS, FETCH_STATUS, PROMO_VALIDATION_STATUS].includes(name);
      var valueIsValid = [_constants.STATUS_IDLE, _constants.STATUS_PENDING, _constants.STATUS_RESOLVED].includes(value);
      if (!nameIsValid || !valueIsValid) {
        /* eslint-disable-next-line no-console */
        console.error('Status metadata name or value is invalid');
        return;
      }
      state.metadata[name] = value;
    },
    resetQuote: function resetQuote(state) {
      sessionStorage.removeItem(_storageKeys.QUOTE_REFERENCE);
      state.quote = _initialQuote.INITIAL_QUOTE;
      state.metadata = {
        initialFetchStatus: _constants.STATUS_IDLE,
        promoValidationStatus: _constants.STATUS_IDLE,
        updateStatus: _constants.STATUS_IDLE
      };
    },
    processSearchParams: function processSearchParams(state, action) {
      var _state$quote, _findBreed, _state$quote2, _breed$isCrossBreed;
      var _action$payload5 = action.payload,
        _action$payload5$sear = _action$payload5.searchParams,
        queryBreed = _action$payload5$sear.breed,
        petName = _action$payload5$sear.petName,
        speciesCode = _action$payload5$sear.species,
        dogBreeds = _action$payload5.dogBreeds,
        catBreeds = _action$payload5.catBreeds;
      if ((_state$quote = state.quote) !== null && _state$quote !== void 0 && _state$quote.hasProcessedParams) return;
      var breedDetails = (_findBreed = (0, _breeds.findBreed)({
        breeds: dogBreeds,
        queryBreed: queryBreed
      }, _constants.DOG_SPECIES_CODE)) !== null && _findBreed !== void 0 ? _findBreed : (0, _breeds.findBreed)({
        breeds: catBreeds,
        queryBreed: queryBreed
      }, _constants.CAT_SPECIES_CODE);
      var _ref = breedDetails || {},
        breed = _ref.breed,
        specie = _ref.specie;
      // If both speciesCode and breed is provided, response from breedDetails will be used
      var specieDetails = (0, _breeds.findSpecie)(specie !== null && specie !== void 0 ? specie : speciesCode);
      var pets = (_state$quote2 = state.quote) !== null && _state$quote2 !== void 0 && (_state$quote2 = _state$quote2.pets) !== null && _state$quote2 !== void 0 && _state$quote2.length ? state.quote.pets : [{
        speciesCode: specieDetails === null || specieDetails === void 0 ? void 0 : specieDetails.speciesCode,
        species: specieDetails === null || specieDetails === void 0 ? void 0 : specieDetails.species,
        petName: petName,
        breed: breed === null || breed === void 0 ? void 0 : breed.description,
        breedCode: breed === null || breed === void 0 ? void 0 : breed.breedCode,
        isCrossBreed: (_breed$isCrossBreed = breed === null || breed === void 0 ? void 0 : breed.isCrossBreed) !== null && _breed$isCrossBreed !== void 0 ? _breed$isCrossBreed : false
      }];
      state.quote = _objectSpread(_objectSpread({}, state.quote), {}, {
        pets: pets,
        hasProcessedParams: true
      });
    }
  }
});
var _quoteSlice$actions = quoteSlice.actions,
  setStatusMetadata = exports.setStatusMetadata = _quoteSlice$actions.setStatusMetadata,
  saveSelectedPetQuote = exports.saveSelectedPetQuote = _quoteSlice$actions.saveSelectedPetQuote,
  removePromotionDetail = exports.removePromotionDetail = _quoteSlice$actions.removePromotionDetail,
  savePromotionDetail = exports.savePromotionDetail = _quoteSlice$actions.savePromotionDetail,
  saveQuote = exports.saveQuote = _quoteSlice$actions.saveQuote,
  resetQuote = exports.resetQuote = _quoteSlice$actions.resetQuote,
  processSearchParams = exports.processSearchParams = _quoteSlice$actions.processSearchParams;